'use strict';

const Timer = props => {
  // const [zIndex, setZIndex] = React.useState("-2");
  const [visible, setVisible] = React.useState("none");
  const [days, setDays] = React.useState(0);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const deadline = props.time;
  const getTime = () => {
    // setZIndex("2");
    setVisible("flex");
    const currentTime = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    });
    const time = Date.parse(deadline) - Date.parse(currentTime);
    setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
    setHours(Math.floor(time / (1000 * 60 * 60) % 24));
    setMinutes(Math.floor(time / 1000 / 60 % 60));
    setSeconds(Math.floor(time / 1000 % 60));
  };
  React.useEffect(() => {
    const interval = setInterval(() => getTime(deadline), 1000);
    return () => clearInterval(interval);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, days < 0 && hours < 0 && minutes < 0 && seconds < 0 ? /*#__PURE__*/React.createElement("div", {
    className: "countdownClock"
  }, "AVAILABLE ON THE APP!", /*#__PURE__*/React.createElement("div", {
    className: "time"
  })) : /*#__PURE__*/React.createElement("div", {
    className: "countdownClock FadeIn",
    style: {
      "zIndex": 2,
      "display": visible
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "time"
  }, /*#__PURE__*/React.createElement("div", {
    className: "digits"
  }, days < 10 ? "0" + days : days), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, "DAYS")), /*#__PURE__*/React.createElement("div", {
    className: "time"
  }, /*#__PURE__*/React.createElement("div", {
    className: "digits"
  }, hours < 10 ? "0" + hours : hours), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, "HOURS")), /*#__PURE__*/React.createElement("div", {
    className: "time"
  }, /*#__PURE__*/React.createElement("div", {
    className: "digits"
  }, minutes < 10 ? "0" + minutes : minutes), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, "MIN")), /*#__PURE__*/React.createElement("div", {
    className: "time"
  }, /*#__PURE__*/React.createElement("div", {
    className: "digits"
  }, seconds < 10 ? "0" + seconds : seconds), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, "SEC"))));
};
